'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M144 368L0 320l82.3 96 115.2 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l115.2 0L576 320 432 368 544 0 336 296 312 128l-48 0L240 304 96 192l48 176zM312 0L264 0l0 24 0 48 0 24 48 0 0-24 0-48 0-24zM32 448L0 448l0 64 32 0 512 0 32 0 0-64-32 0L32 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;